import React from "react";

const SITES = [
  { key: "VIG", label: "V", domain: "vigliettisport.com" },
  { key: "BOT", label: "B", domain: "botteroski.com" },
];

const normalizeText = (value) => String(value ?? "").trim().toLowerCase();

export const normalizePrestashopNumber = (value) => {
  if (value == null || String(value).trim() === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : normalizeText(value);
};

export const renderPrestashopVisibility = (value) => {
  const normalized = normalizeText(value);
  if (normalized === "both") return "Si";
  if (normalized === "none") return "No";
  return value ?? "";
};

export default function PrestashopSitesCell({
  row,
  field,
  legacyValue,
  normalizeValue = normalizeText,
  renderValue = (value) => value ?? "",
}) {
  const sites = row.prestashopSites;
  if (!sites) return <>{legacyValue}</>;

  if (sites.VIG && sites.BOT &&
      normalizeValue(sites.VIG[field]) === normalizeValue(sites.BOT[field])) {
    return <>{renderValue(sites.VIG[field])}</>;
  }

  return (
    <div className="flex flex-column items-start mw-100 pv1 f7 lh-copy">
      {SITES.map(({ key, label, domain }) => {
        const value = sites[key]?.[field];
        return (
          <span
            key={key}
            className="dib mw-100 ba br2 ph1 mv1 bordoColAlt sfondoColChiaro"
            style={{ overflowWrap: "anywhere" }}
            title={`${domain}: ${value == null || String(value).trim() === "" ? "—" : value}`}
          >
            {label}: {sites[key] && value != null && String(value).trim() !== ""
              ? renderValue(value) : "—"}
          </span>
        );
      })}
    </div>
  );
}
